import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "../lib/api";

const RETRY_MS = 4000;

export const ConnectionBanner = () => {
  const [offline, setOffline] = useState(false);
  useEffect(() => {
    const off = () => setOffline(true);
    const on = () => setOffline(false);
    window.addEventListener("dc-offline", off);
    window.addEventListener("dc-online", on);
    return () => {
      window.removeEventListener("dc-offline", off);
      window.removeEventListener("dc-online", on);
    };
  }, []);
  useEffect(() => {
    if (!offline) return undefined;
    const t = setInterval(() => api.get("/").catch(() => {}), RETRY_MS);
    return () => clearInterval(t);
  }, [offline]);
  if (!offline) return null;
  return (
    <div data-testid="connection-banner" role="status"
      className="fixed left-60 right-0 top-0 z-50 flex items-center justify-center gap-2 border-b border-amber-500/40 bg-amber-950/90 py-2 font-mono text-xs uppercase tracking-widest text-amber-300 backdrop-blur">
      <RefreshCw className="h-3.5 w-3.5 animate-spin" />
      Sem ligação ao servidor — a reconectar…
    </div>
  );
};
